import { IApiSuccessWrapper, IFeatureFlags } from '$/types'
import { apiSlice } from 'app/services/api'

export const featureFlagsApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getFeatureFlags: build.query<IFeatureFlags, void>({
      query: () => '/featureflags',
      transformResponse: (res: IApiSuccessWrapper<IFeatureFlags>) => {
        return res.result
      }
    })
  })
})

export const { useGetFeatureFlagsQuery } = featureFlagsApi
